import type { RunePeriod } from './rune-market-data'
import { indexedSaleChange } from './market-metrics'
export type TokenRanking = 'volume' | 'gainers' | 'losers'
export function rankActiveTokens<T extends { slug: string; volume_week?: number; change_week_vwap?: number | null; change_week_fair?: number | null }>(markets: T[], ranking: TokenRanking): T[] {
 return markets.filter(m => Number.isFinite(m.volume_week) && (m.volume_week ?? 0) > 0).filter(m => {
  const change = indexedSaleChange(m)
  return ranking === 'volume' || (change !== null && (ranking === 'gainers' ? change >= 0.005 : change <= -0.005))
 }).sort((a,b) => {
  const difference = ranking === 'volume' ? (b.volume_week ?? 0) - (a.volume_week ?? 0) : ranking === 'gainers' ? indexedSaleChange(b)! - indexedSaleChange(a)! : indexedSaleChange(a)! - indexedSaleChange(b)!
  return difference || (b.volume_week ?? 0) - (a.volume_week ?? 0) || a.slug.localeCompare(b.slug)
 })
}

const VOLUME_FIELDS = { '6h': 'volume_six_hour', '1d': 'volume_day', '7d': 'volume_week', '30d': 'volume_month' } as const
type PeriodVolumes = Partial<Record<(typeof VOLUME_FIELDS)[RunePeriod], number>>
export function tokenVolumeForPeriod(market: PeriodVolumes, period: RunePeriod): number {
 const value = market[VOLUME_FIELDS[period]]
 return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : 0
}
export function rankTokensForPeriod<T extends PeriodVolumes & { slug: string }>(markets: T[], period: RunePeriod): T[] {
 return markets.filter(market => tokenVolumeForPeriod(market, period) > 0)
  .sort((a, b) => tokenVolumeForPeriod(b, period) - tokenVolumeForPeriod(a, period) || a.slug.localeCompare(b.slug))
}
